import React from 'react'
import Head from 'next/head'
import { WebsiteLayout } from '@website/components/layout/WebsiteLayout'
import { Meta } from '@website/components/Meta'
import { HeroBasic } from '@ui/hero'
import {
  MainBlockAboutEmpowering,
  MainBlockAboutMeetTheTeam,
  MainBlockWavyOffWhite,
} from '@ui/main-blocks'
import {
  MainBlockAboutEmpoweringImage,
  MainBlockAboutHeadshotsImage,
} from '@website/components/images'

const title = 'About Us, Our Mission & Who We Are'
const canonical = 'https://www.atm.com/about'
const description =
  'ATM.com is an all-in-one finance app that empowers users with ATM Instant Cash™, providing quick access to cash advances, budgeting tools, financial management support, and a variety of ways to earn extra money through games, surveys, and cashback rewards.'
const image = '/img/og/og-atm-1.png'

export function Index() {
  return (
    <>
      <Head>
        <title>{title}</title>
        <Meta
          title={title}
          description={description}
          canonical={canonical}
          image={image}
        />
      </Head>
      <WebsiteLayout>
        <HeroBasic
          title="Our Mission"
          description="We believe that everyone deserves financial peace of mind."
        />
        <MainBlockAboutEmpowering className="pb-0">
          <MainBlockAboutEmpoweringImage />
        </MainBlockAboutEmpowering>
        <MainBlockWavyOffWhite />
        <MainBlockAboutMeetTheTeam
          HeadshotComponent={MainBlockAboutHeadshotsImage}
        />
      </WebsiteLayout>
    </>
  )
}

export default Index
